import { render, staticRenderFns } from "./BidForm.vue?vue&type=template&id=1912bc74"
import script from "./BidForm.vue?vue&type=script&lang=js"
export * from "./BidForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports